
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/pegasus-solar",
      function () {
        return require("private-next-pages/success-stories/pegasus-solar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/pegasus-solar"])
      });
    }
  